import { InjectionToken } from '@angular/core';
import { CommonAddressConfig } from '../interfaces/common-address-config.interface';

export const COMMON_ADDRESS_CONFIG = new InjectionToken<CommonAddressConfig>('COMMON_ADDRESS_CONFIG');
